module.exports = __webpack_public_path__ + "media/images/real-mimi-e011ea37db9e790921f9dcc055dd3b49.png";